// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2BdyJ","colBig":"styles_colBig__3z_at","colSmall":"styles_colSmall__3Tgkw","shopifyNameWrapper":"styles_shopifyNameWrapper__Yxsug"};